export enum FlowLayoutModeE {
    Default = "Default",
    ColumnBased = "ColumnBased"
}